import React, {useState} from 'react';
import {Form, Input, Button, Checkbox, Carousel} from 'antd';
import {UserOutlined, LockOutlined, CopyrightOutlined} from '@ant-design/icons';
import {http, history, addVisitLog} from 'libs';
import styles from './login.module.less';
import bannerEn1 from './banner/en/1.jpeg'
import bannerEn2 from './banner/en/2.jpeg'
import bannerEn3 from './banner/en/3.jpeg'

import bannerZh1 from './banner/zh/1.jpeg'
import bannerZh2 from './banner/zh/2.jpeg'
import bannerZh3 from './banner/zh/3.jpeg'

// the hook
import {useTranslation} from 'react-i18next';

export default function Login() {
  const {t, i18n} = useTranslation();
  const [loading, setLoading] = useState(false);

  const username = localStorage.getItem('username');
  const password = localStorage.getItem('password');
  const remember = localStorage.getItem('remember');

  function handleSubmit(formData) {
    setLoading(true);
    const f_Data = formData;
    f_Data['from'] = 2;
    http.post('/api/front/login/', f_Data)
      .then(data => {
        localStorage.setItem('token', data['token']);
        localStorage.setItem('username', data['username']);
        localStorage.setItem('password', data['password']);
        localStorage.setItem('remember', formData['remember']);
        http.get('/javaApi/front/customer/getUserInfo')
        .then(res => {
          console.log(res,'res');
          const userInfo=res.data.result;
          addVisitLog({
            pageName: "登录",
            fromPageUrl: window.referrerUrl,
            pageUrl:`${window.location.origin}${history.location.pathname}`,
            eventCode: "Login",
            eventName: "登录",
            content: JSON.stringify(userInfo)
          })
          // localStorage.setItem('nickname', res.data.result['name']);
          // localStorage.setItem('userInfo', JSON.stringify(res.data.result));
          localStorage.setItem('nickname', userInfo['name']);
            localStorage.setItem('userInfo', JSON.stringify(userInfo));

            if (history.location.state && history.location.state['from']) {
              history.push(history.location.state['from'])
            } else {
              let redirect_uri = localStorage.getItem('redirect_uri')
              history.push(redirect_uri ? redirect_uri : '/home')
            }
        })
      }, () => setLoading(false))
  }

  return (
    <div className={styles.container}>


      <div className={styles.carousel}>
        {/* <Carousel autoplay>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn1 : bannerZh1) + '")'}}/>
          </div>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn2 : bannerZh2) + '")'}}/>
          </div>
          <div>
            <div className={styles.item}
                 style={{backgroundImage: 'url("' + (i18n.language === 'en' ? bannerEn3 : bannerZh3) + '")'}}/>
          </div>
        </Carousel> */}
      </div>


      <div className={styles.formContainer}>
        <div className={styles.h1}>{t('请登录您的账号')}</div>
        <Form onFinish={handleSubmit}
              initialValues={remember === 'true' ? {username: username, password: password, remember: true} : null}>

          <Form.Item name="username" className={styles.formItem}>
            <Input
              size="large"
              placeholder={t('手机号/邮箱')}
              prefix={<UserOutlined className={styles.icon}/>}/>
          </Form.Item>

          <Form.Item name="password" className={styles.formItem}>
            <Input
              size="large"
              type="password"
              placeholder={t('请输入密码')}
              prefix={<LockOutlined className={styles.icon}/>}/>
          </Form.Item>

          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>{t('自动登录')}</Checkbox>
            </Form.Item>

            <a className={styles['form-forgot']} target="_blank"
               href="https://lab-direct.com/LabDirect/Forget/">{t('忘记密码') + '？'}</a>
          </Form.Item>

          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" loading={loading}>{t('登录')}</Button>
            <div className={styles.formTip}>
              {t('如果您没有平台账号')} <a onClick={() => {
              history.push('/register')
            }}>{t('立即注册')}!</a>
            </div>
          </Form.Item>

        </Form>
      </div>


    </div>
  )
}
